module.exports = "input.cbm-table-header-filter {\n  width: 100%; }\n\nspan.cbm-column-header {\n  overflow-wrap: normal !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/datatable/cbm-table.component.scss
// module id = ./src/app/shared/datatable/cbm-table.component.scss
// module chunks = main